import type { TranslationKey } from "@shared/i18n/translationKey";

// Constantes de dominio del módulo preinvoice. Centralizan los magic strings que
// estaban repartidos por la página, el item y el flujo de generación de factura.

// Endpoints del ciclo de prefactura (todos bajo /v1/ vía CustomAxios).
export const PREINVOICE_ENDPOINT = {
  ADD_ITEM: "pre-invoices/add-item",
  ADD_ITEM_LAST_MONTH: "pre-invoices/add-item/last-month",
  PENDING: "pre-invoices/pending",
  CONFIRM: "invoices/confirm-pre-invoice/",
  SEND: "invoices/send",
};

// Códigos de estado que el backend devuelve en el body (statusCode) y en el code
// de error. 100 = info (hay observaciones), 200 = ok, 400 = error de validación.
export const HTTP_STATUS = { SUCCESS: 200, INFO: 100, BAD_REQUEST: 400 };

// Colores de los diálogos de confirmación (sweetalert2).
export const SWAL_COLOR = { CONFIRM: "#3085d6", CANCEL: "#d33", DENY: "#049942" };

// Cantidad de meses hacia atrás que ofrece el selector de período manual.
export const MONTHS_LOOKBACK = 6;

// Estados de una prefactura/factura (enum estable que devuelve el backend).
export const PREINVOICE_STATUS = {
  CREATED: "CREATED",
  SENT: "SENT",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED",
  REPLACED: "REPLACED",
  PAID: "PAID",
  POSTED: "POSTED",
  ACCEPTED: "ACCEPTED",
};

// Meta de presentación por estado: clave i18n + color de fondo del Chip.
export const STATUS_CHIP_META = {
  [PREINVOICE_STATUS.CREATED]: { labelKey: "created", color: "#2962ff" },
  [PREINVOICE_STATUS.SENT]: { labelKey: "sent", color: "#4bd86d" },
  [PREINVOICE_STATUS.REJECTED]: { labelKey: "rejected", color: "#d47510" },
  [PREINVOICE_STATUS.CANCELLED]: { labelKey: "cancelled", color: "#d42d10" },
  [PREINVOICE_STATUS.REPLACED]: { labelKey: "replaced", color: "#f9a825" },
  [PREINVOICE_STATUS.PAID]: { labelKey: "paid", color: "#9c27b0" },
  [PREINVOICE_STATUS.POSTED]: { labelKey: "posted", color: "#0d47a1" },
  [PREINVOICE_STATUS.ACCEPTED]: { labelKey: "accepted", color: "#4caf50" },
} satisfies Record<string, { labelKey: TranslationKey; color: string }>;
